import { trackAnalyticsEvent } from '@eb/site-analytics';

const PROTEST_MAP_GA_CATEGORY = 'protest-map';

export const trackViewEvent = (eid) => {
    trackAnalyticsEvent({
        category: PROTEST_MAP_GA_CATEGORY,
        action: 'ViewEvent',
        label: eid,
    });
};

export const trackSeeMore = () => {
    trackAnalyticsEvent({
        category: PROTEST_MAP_GA_CATEGORY,
        action: 'SeeMore',
    });
};

export const trackCreateClick = () => {
    trackAnalyticsEvent({
        category: PROTEST_MAP_GA_CATEGORY,
        action: 'CreateCTA',
    });
};
